import {EventEmitter, Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {LocalStorage} from '../../storage.class';
import {User} from '../../classes/user.class';
import {AuthResponse} from '../../classes/auth-response';
import {Router} from '@angular/router';
import {ConfirmDialogService} from "../confirm-dialog-service/confirm-dialog.service";
import {map} from 'rxjs/operators';
import {Routenames} from '../../classes/route-name.enum';

@Injectable()
export class AuthService {

    loggedIn = new EventEmitter<boolean>();

    constructor(public apiService: ApiService, private router: Router, private confirmDialogService: ConfirmDialogService) {
    }

    login(email, password) {
        return this.apiService.postCall$<AuthResponse>('auth/login', {email, password})
            .pipe(map(response => this.handleResponse(response.data as AuthResponse)));
    }

    loginEmail(email) {
        return this.apiService.postCall$<boolean>('auth/login-email', {email});
    }

    loginType(email) {
        return this.apiService.postCall$<{
            needspassword: boolean
        }>('auth/login-type', {email});
    }

    handleMicrosoftCallback(code: string, state: string) {
        return this.apiService.getCallData$<AuthResponse>('auth/microsoft/callback', {code, state})
            .pipe(map(response => this.handleResponse(response as AuthResponse)));
    }

    loginWithMicrosoft() {
        return this.apiService.getCallData$<{ auth_url: string }>('auth/microsoft/login');
    }

    public logout() {

        this.confirmDialogService.confirm(
            'Uitloggen',
            `U wordt uitgelogd... <i class="fas fa-spinner fa-spin"></i>`,
            null,
            null
        ).then(() => {
            console.log("LOGOUT A");
            window.location.reload();
        });
        this.apiService.postCall('auth/logout').then(() => {
            LocalStorage.logoutUser();
            setTimeout(() => {
                console.log("LOGOUT B");
                window.location.reload();
            });
        }, () => {
            LocalStorage.logoutUser();
            setTimeout(() => {
                console.log("LOGOUT C");
                window.location.reload();
            });
        });
    }

    public getUserDetails() {
        return this.apiService.getCallData$<User>('auth/me').pipe(map(response => {
            LocalStorage.setUser(response);
            return response;
        }));
    }

    public refresh(token?: string) {
        if (token) {
            return this.apiService.postCall$<AuthResponse>('auth/refresh', {token})
                .pipe(map(response => this.handleResponse(response.data as AuthResponse)));
        }
        return this.apiService.getCallData$<AuthResponse>('auth/refresh')
            .pipe(map(response => this.handleResponse(response)));
    }

    private handleResponse(authResponse: AuthResponse) {
        if (!!authResponse.access_token) {
            LocalStorage.setUserToken(authResponse.access_token);
            LocalStorage.setUser(authResponse.user);
            LocalStorage.setExpireTimeToken(authResponse.expires_in);
            this.loggedIn.emit(true);
            return authResponse;
        } else {
            this.loggedIn.emit(false);
            this.router.navigate([Routenames.logout]);
        }
    }
}
